let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gNlLk")).then(() => parcelRequire('2525D'));